import visible from './visible.directive.js';

/**
 * @ngdoc module
 * @name spy.spies
 */
const mod = angular.module('spy.spies', [
    visible.name
]);

export default mod;
